module.exports = __webpack_public_path__ + "img/school.e02bbc2f.png";